import { Form, Input, Button } from 'antd';
import { UserOutlined, MobileOutlined } from '@ant-design/icons';
import '../index.css';
import { IResult } from '../../components/infrastructure/models';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { Core } from '../../components/infrastructure/core';
import { Captcha } from '../../components/captcha';
import AppContext from '../../components/infrastructure/appContext';
import SimplePage from '../../home/simplePage';

interface IForgetPasswordState {
    success?: boolean;
    loading?: boolean;
    userName?: string;
}

export const ForgetPassword = () => {
    const { params } = React.useContext(AppContext);
    const [state, setState] = React.useState<IForgetPasswordState>({ success: false, userName: params['username'] ?? '' });
    const [form] = Form.useForm();

    const onFinish = async (values: any) => {
        if (state.loading)
            return;
        await sendActivationCode(values);
    };

    const sendActivationCode = async (values: any) => {
        setState({ ...state, loading: true });
        let response = await fetch("api/user/forgetpassword", {
            method: 'POST',
            body: JSON.stringify({
                userName: values['username'],
                phoneNumber: values['phonenumber'],
                captcha: values['captcha']
            }),
            headers: { 'content-type': 'application/json;charset=UTF-8' }
        });
        console.log(response.status);
        let result: IResult = await response.json();
        if (!result.ValidationState.Successful) {
            Core.errorNotification(result.ValidationState.ValidationResults[0].Message);
            setState({ ...state, loading: false });
        }
        else {
            Core.successNotification(result.ValidationState.ValidationResults[0].Message);
            setState({ ...state, success: true });
            form.setFields([{ name: "captcha", value: "" }]);
        }
    };

    React.useEffect(() => {
        // componentDidMount
        let container = document.getElementById("container");
        if (container && !container.classList.contains("custom-scroll")) {
            container.style.overflow = "auto";
            container.classList.add("custom-scroll");
        }

        return () => {
            // componentWillUnmount
        };
    }, []);

    if (state.success) {
        const userName = form.getFieldValue('username');
        return <Redirect to={{ pathname: '/login', search: (userName ? '?username=' + userName : '') }} />
    }

    return (
        <SimplePage>
            <div className="box box-blue" style={{ border: "1px solid white", borderTopLeftRadius: 15, borderTopRightRadius: 15 }}>
                <img src={'/forgetpassword.png'} style={{ marginTop: 20, width: 80 }} alt="" />
                <p className="" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', fontSize: 18, fontWeight: "bold", color: "antiquewhite" }}>بازنشانی کلمه عبور</p>
            </div>
            <Form
                form={form}
                //labelCol={{ span: 6 }}
                wrapperCol={{ span: 24 }}
                name="normal_login"
                className="box login-form"
                onFinish={onFinish}
                style={{ paddingLeft: 50, paddingRight: 50, paddingBottom: 50, paddingTop: 5, border: "1px solid white", backgroundColor: "#fefefe90", borderBottomLeftRadius: 15, borderBottomRightRadius: 15, width: "100%", textAlign: "right" }}
            >
                <Form.Item
                    name="username"
                    //label="نام کاربری"
                    rules={[
                        { required: true, message: 'لطفا نام کاربری را وارد نمایید' },
                        {
                            required: true,
                            validator: async () => {
                                const userName = form.getFieldValue('username');
                                if (Core.isNationalCode(userName))
                                    return Promise.reject(new Error('نام کاربری نمیتواند کد ملی باشد'));
                                return Promise.resolve();
                            }
                        }
                    ]}
                    initialValue={state.userName}
                >
                    <Input
                        autoComplete="off"
                        prefix={<UserOutlined className="site-form-item-icon" />}
                        placeholder="نام کاربری"
                    />
                </Form.Item>
                <Form.Item
                    name="phonenumber"
                    //label="شماره موبایل"
                    rules={[
                        { len: 11, message: 'شماره موبایل باید 11 رقم باشد' },
                        {
                            validator: () => {
                                const phonenumber = form.getFieldValue('phonenumber');
                                if (!phonenumber)
                                    return Promise.reject(new Error('شماره موبایل را وارد نمایید'));
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <Input
                        placeholder="شماره موبایل"
                        style={{ width: "100%" }}
                        type="text"
                        prefix={<MobileOutlined className="site-form-item-icon" />}
                        onKeyPress={(event: any) => {
                            if (event.charCode < 48 || event.charCode > 57) {
                                event.preventDefault();
                            }
                        }}
                    />

                </Form.Item>

                {!state.loading &&
                    <Captcha
                        form={form}
                        name="captcha"
                        label="متن تصویر"
                    />
                }

                <Form.Item style={{ direction: 'ltr', textAlign: 'justify' }} >
                    <Button type="primary" htmlType="submit" className="login-form-button" loading={state.loading}>
                        <>درخواست</>
                    </Button>
                    <Button type="default" htmlType="reset" className="login-form-button" loading={state.loading} onClick={() => {
                        setState({ ...state, success: true });
                    }}>
                        لغو
                    </Button>
                </Form.Item>
            </Form>
        </SimplePage>
    );
};

